// Products API: /api/productapi/GetProducts/{categoryId}/{manufacturer}/{industry}/{pageNumber}/{pageId}/{language} - 'all' is default
// Filters API: /api/productapi/getdropdowns/{defaultcategory (first in list)}/{pageID}
// Functionality: "tabs" (all/software) resets dropdown filters and pager to 1, when filtering via drop downs, pager is reset to start on page 1


if ($('.product-overview-page').length > 0) {

    var breakpoints = {
        sm: 576,
        md: 768,
        lg: 992,
        xl: 1260
    },
        viewportWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth,
        getUrl = window.location,
        baseUrl = getUrl.protocol + "//" + getUrl.host + "/" + getUrl.pathname.split('/')[0],
        defaultCategoryId = $('.tabs-filter .nav-link:first-of-type').attr('data-categoryid'),
        maxVisible = 10,
        language = $('html').attr('lang');

    if (viewportWidth < breakpoints.md) {
        maxVisible = 5;
    }
    if (viewportWidth < breakpoints.sm) {
        maxVisible = 3;
    }



    // get params from url
	var getUrlParameter = function getUrlParameter(sParam) {
		var sPageURL = decodeURIComponent(window.location.search.substring(1)),
			sURLVariables = sPageURL.split('&'),
			sParameterName,
			i;

		for (i = 0; i < sURLVariables.length; i++) {
			sParameterName = sURLVariables[i].split('=');

			if (sParameterName[0] === sParam) {
				return sParameterName[1] === undefined ? true : sParameterName[1];
			}
		}
	};


	var categoryId = getUrlParameter('categoryId') === undefined ? defaultCategoryId : getUrlParameter('categoryId'),
		manufacturer = getUrlParameter('manufacturer') === undefined ? 'all' : getUrlParameter('manufacturer'),
		industry = getUrlParameter('industry') === undefined ? 'all' : getUrlParameter('industry'),
		pageNumber = getUrlParameter('pageNumber') === undefined ? '1' : getUrlParameter('pageNumber'),
		language = getUrlParameter('language') === undefined ? $('html').attr('lang') : getUrlParameter('language');







    // render default drop down filters
    var pageId = $('.product-overview-page').attr('data-pagetypeid'),
        filtersUrl = baseUrl + 'api/productapi/getdropdowns/' + defaultCategoryId + '/' + pageId + '/' + language + '/' + manufacturer + '/' + industry;

    $.get(filtersUrl, function(data) {
        $('.product-filters').html(data);
    });





    // push params to url
    $.fn.pushState = function(categoryId, manufacturer, industry, pageNumber) {
	    if (categoryId == undefined || categoryId == ' ') {
		    categoryId = defaultCategoryId;
	    }
        if (manufacturer == undefined || manufacturer == ' ') {
		    manufacturer = 'all';
	    }
	    if (industry == undefined || industry == ' ') {
		    industry = 'all';
	    }
	    if (pageNumber == undefined || pageNumber == ' ') {
		    pageNumber = '1';
	    }

	    history.pushState(null, null, '?categoryId=' + categoryId + '&manufacturer=' + manufacturer + '&industry=' + industry + '&pageNumber=' + pageNumber + '&language=' + language);
    };




    // Update products list with filtered products
    $.fn.renderFilteredProducts = function() {
	    categoryId = getUrlParameter('categoryId') === undefined ? defaultCategoryId : getUrlParameter('categoryId'),
		manufacturer = getUrlParameter('manufacturer') === undefined ? 'all' : getUrlParameter('manufacturer'),
		industry = getUrlParameter('industry') === undefined ? 'all' : getUrlParameter('industry'),
		pageNumber = getUrlParameter('pageNumber') === undefined ? '1' : getUrlParameter('pageNumber');

        var productsUrl = baseUrl + 'api/productapi/getproducts/'+ categoryId + '/' + manufacturer + '/' + industry + '/' + pageNumber + '/' + pageId + '/' + language;

        $.get(productsUrl , function(data) {
            $('.block-cards__grid .card-deck__products').html(data.Html).hide().fadeIn();
        });
        $(window).scrollTop(0);

    };




    // render pagination
    $.fn.pagination = function (pages) {
        if (pages > 1 && pages < maxVisible) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: pages,
                wrapClass: 'pagination justify-content-center',
                next: ' ',
                prev: ' ',
                nextClass: 'hidden',
                prevClass: 'hidden',
                page: pageNumber,
                firstLastUse: false
            });
        } else if (pages > 1) {
            $('#pagination').bootpag({
                total: pages,
                maxVisible: maxVisible,
                wrapClass: 'pagination justify-content-center',
                next: '. . .',
                prev: '. . .',
                page: pageNumber,
                firstLastUse: true,
                first: '',
                last: ''
            });
        } else {
            $('#pagination ul').remove();
        }
    };





    // Update list on pagination click
    $.fn.paginationClick = function() {
        $('#pagination').unbind('page').bootpag().on('page', function(event, pageNumber){
	        $.fn.pushState(categoryId, manufacturer, industry, pageNumber);
	        $.fn.renderFilteredProducts();
        });
    };

    // initiate pagination listener
    $.fn.paginationClick();





    // Get initial products list with default vars, number of pages and render pagination
    var productsUrl = baseUrl + 'api/productapi/getproducts/'+ categoryId + '/' + manufacturer + '/' + industry + '/' + pageNumber + '/' + pageId + '/' + language;

    $.get(productsUrl, function(data) {
        $('.block-cards__grid .card-deck__products').html(data.Html);
        $.fn.pagination(data.Pages);
    });





    // reset all filters
    $('#reset').on('click', function() {
	    categoryId = defaultCategoryId,
	    manufacturer = 'all',
	    industry = 'all',
	    pageNumber = '1';

	    $.fn.pushState(categoryId, manufacturer, industry, pageNumber);

        window.location.reload();
    });




    // filter product by category tabs - update pagination with correct number of pages - start on page 1 and reset drop down filters
    $('.tabs-filter .nav-link').on('click', function() {
        categoryId = $(this).attr('data-categoryid'),
	    pageNumber = '1';

	    // reset dropdown filters if something is already selected
        if (manufacturer != 'all' || industry != 'all') {
	        manufacturer = 'all',
	        industry = 'all',
	        filtersUrl = baseUrl + 'api/productapi/getdropdowns/' + categoryId + '/' + pageId + '/' + language + '/' + manufacturer + '/' + industry;

	        $.get(filtersUrl, function(data) {
		        $('.product-filters').html(data);
	        });
        }

        $(this).addClass('active').siblings().removeClass('active');

        // update drop down filters options depending on category (and reset options)
        var filtersUrl = baseUrl + 'api/productapi/getdropdowns/' + categoryId + '/' + pageId + '/' + language;
        $.get(filtersUrl, function(data) {
            $('.product-filters').html(data);
        });

        // add categoryId to url
	    $.fn.pushState(categoryId);

        // get first page of tabs-filtered products
        $.fn.renderFilteredProducts();

        // and pagination
        var productsUrl = baseUrl + 'api/productapi/getproducts/'+ categoryId + '/' + manufacturer + '/' + industry + '/' + pageNumber + '/' + pageId + '/' + language;
        $.get(productsUrl , function(data) {
            $.fn.pagination(data.Pages);
        });

        $.fn.paginationClick();
    });





    // filter products by dropdowns: manufacturer and industry - update pagination with correct number of pages - start on page 1
    $('.product-filters').on('change', function() {

        $('#manufacturer, #industry').children(':selected').attr('selected', 'selected').siblings().removeAttr('selected');

        manufacturer = $('#manufacturer option:selected').val(),
        industry = $('#industry option:selected').val(),
	    pageNumber = '1';

        // add params to url
	    $.fn.pushState(categoryId, manufacturer, industry, pageNumber, language);

        // get first page of select-filtered products
        $.fn.renderFilteredProducts();

        // and render pagination
        var productsUrl = baseUrl + 'api/productapi/getproducts/'+ categoryId + '/' + manufacturer + '/' + industry + '/' + pageNumber + '/' + pageId + '/' + language;
        $.get(productsUrl , function(data) {
            $.fn.pagination(data.Pages);
        });

        $.fn.paginationClick();

    });



	// set active tab and filters to url params if link is copied
	$('nav.tabs-filter .nav-link').each(function() {
		if ($(this).attr('data-categoryid') == categoryId) {
			$(this).addClass('active').siblings().removeClass('active');
		}
	});

};

